'use client'
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__base_ui_components_react_radio_group_054f4dac__ from "@base-ui-components/react/radio-group";
import * as __WEBPACK_EXTERNAL_MODULE__RadioWithLabel_RadioWithLabel_js_4e3483f3__ from "../RadioWithLabel/RadioWithLabel.js";
import * as __WEBPACK_EXTERNAL_MODULE__RadioGroup_variants_js_dfcead86__ from "./RadioGroup.variants.js";
import * as __WEBPACK_EXTERNAL_MODULE__utils_index_js_02c78a7f__ from "../../../utils/index.js";
function RadioGroup({ name, defaultValue, handleChange, className = '', options, disabled, required, layout, ...props }) {
    const { radioGroup } = (0, __WEBPACK_EXTERNAL_MODULE__RadioGroup_variants_js_dfcead86__.radioGroupVariants)({
        layout
    });
    const classes = (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_02c78a7f__.cn)(radioGroup(), className);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_radio_group_054f4dac__.RadioGroup, {
        disabled: disabled,
        name: name,
        defaultValue: defaultValue,
        onValueChange: handleChange,
        className: classes,
        required: required,
        ...props,
        children: options.map((option)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__RadioWithLabel_RadioWithLabel_js_4e3483f3__.RadioWithLabel, {
                ...option,
                value: String(option.value),
                layout: layout,
                isRadioGroup: true
            }, option.value))
    });
}
export { RadioGroup };
